import React from "react";

import CardAllUsers from "../../Cards/CardAllUsers";

const Users = () => {
  return (
    <div>
      <CardAllUsers />
    </div>
  );
};

export default Users;
